<template>
    <div class="form-group">
        <label :for="'select-logical-option-value-' + formIndex" v-if="formIndex === 1">
            {{ $lang('Spójnik') }}
        </label>
        <select
            v-model="selectValue"
            @change="onChangeSelectValue"
            :id="'select-logical-option-value-' + formIndex"
            class="form-control"
        >
            <option
                v-for="option of options"
                :key="'logical-option-' + formIndex + '-' + option.value"
                :value="option.value"
                :selected="option.value === initValue"
            >
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        name: 'logical-operation-select',
        props: {
            formIndex: {
                type: Number,
                required: true
            },
            initValue: {
                type: String,
                default: 'AND'
            }
        },
        data() {
            return {
                selectValue: this.initValue,
                options: [
                    { value: 'AND', label: this.$lang('AND') },
                    { value: 'OR' , label: this.$lang('OR') }
                ]
            };
        },
        methods: {
            onChangeSelectValue() {
                this.$emit('change', this.selectValue);
            }
        }
    };
</script>
